<!-- Applications page -->
<div class="cd-section" id="accounts" style="background-color: white;">
  <div class="container">
    <div class="features-2">
      <div class="row text-center">
        <div class="col-md-12">
          <h2 class="title text-center">RegScale Dashboard</h2>
          <h5 class="description">This dashboard helps visualize the sales pipeline for the RegScale website funnel. It
            is also used to manage customers including contacts and licence keys.</h5>
        </div>
      </div>

      <div class="row col-md-12">

        <!-- Customers -->
        <div class="col-md-6 mt-4">
          <div class="card h-100">
            <div class="card-body text-center">
              <h5 class="card-category card-category-social text-success">
                <i class="fas fa-dollar-sign fa-5x"></i>
              </h5>
              <h4 class="card-title">
                Customers
              </h4>
              <p class="card-description">
                Manage customers including license keys
              </p>
              <div class="footer text-center">
                <a [routerLink]="['/customers']" class="btn btn-rose btn-round">
                  <i class="material-icons">link</i> Go
                </a>
              </div>
            </div>
          </div>
        </div>

        <!-- Leads -->
        <div class="col-md-6 mt-4">
          <div class="card h-100">
            <div class="card-body text-center">
              <h5 class="card-category card-category-social text-success">
                <i class="far fa-id-badge fa-5x"></i>
              </h5>
              <h4 class="card-title">
                Leads
              </h4>
              <p class="card-description">
                Captured leads from RegScale.com
              </p>
              <div class="footer text-center">
                <a [routerLink]="['/leads']" class="btn btn-rose btn-round">
                  <i class="material-icons">link</i> Go
                </a>
              </div>
            </div>
          </div>
        </div>

        <!-- News -->
        <div class="col-md-6 mt-4">
          <div class="card h-100">
            <div class="card-body text-center">
              <h5 class="card-category card-category-social text-success">
                <i class="fas fa-newspaper fa-5x"></i>
              </h5>
              <h4 class="card-title">
                News
              </h4>
              <p class="card-description">
                Press and Related Media
              </p>
              <div class="footer text-center">
                <a [routerLink]="['/news']" class="btn btn-rose btn-round">
                  <i class="material-icons">link</i> Go
                </a>
              </div>
            </div>
          </div>
        </div>

        <!-- Partners -->
        <div class="col-md-6 mt-4">
          <div class="card h-100">
            <div class="card-body text-center">
              <h5 class="card-category card-category-social text-success">
                <i class="fas fa-handshake fa-5x"></i>
              </h5>
              <h4 class="card-title">
                Partners
              </h4>
              <p class="card-description">
                Resellers and System Integrators
              </p>
              <div class="footer text-center">
                <a [routerLink]="['/partners']" class="btn btn-rose btn-round">
                  <i class="material-icons">link</i> Go
                </a>
              </div>
            </div>
          </div>
        </div>

        <!-- Registrations -->
        <div class="col-md-6 mt-4">
          <div class="card h-100">
            <div class="card-body text-center">
              <h5 class="card-category card-category-social text-success">
                <i class="fas fa-key fa-5x"></i>
              </h5>
              <h4 class="card-title">
                Registrations
              </h4>
              <p class="card-description">
                Self-service registrations of RegScale CE license keys
              </p>
              <div class="footer text-center">
                <a [routerLink]="['/registrations']" class="btn btn-rose btn-round">
                  <i class="material-icons">link</i> Go
                </a>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
</div>